import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const DocumentModule = new Module<Types.DocumentFragment, Types.GetDocumentsQueryVariables, Types.Documents_Insert_Input>({
    sortKey: 'created_at',
})